import wordmark from "./assets/brand/mindset-wordmark-reverse.svg";
import "./brandLogo.css";

export function BrandLogo() {
  return <img className="mindset-brand-logo" src={wordmark} alt="Mindset" width="1458" height="385" />;
}
